import { IconError } from "@/Icons/Error";
import { IconInfo } from "@/Icons/Info";
import { IconSuccess } from "@/Icons/Success";
import { IconWarning } from "@/Icons/Warning";

export const alertConfig = {
  success: {
    icon: <IconSuccess />,
    className: "border-carrot-green bg-light-lichen",
  },
  warning: {
    icon: <IconWarning />,
    className: "border-carrot-orange bg-light-orange",
  },
  error: {
    icon: <IconError />,
    className: "border-carrot-red bg-light-peach",
  },
  info: {
    icon: <IconInfo />,
    className: "border-carrot-orange bg-light-orange",
  },
};
